__turbopack_context__.v({
  "card-back-grid": "CardSideBack-module-scss-module__Bfs91q__card-back-grid",
  "content-container": "CardSideBack-module-scss-module__Bfs91q__content-container",
  "minus-icon": "CardSideBack-module-scss-module__Bfs91q__minus-icon",
});
